import { useReportStore } from '../../stores/reportStore';

export default function TranscriptionDisplay() {
  const { transcription, setTranscription, isTranscribing } = useReportStore();

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
        Transcription
      </label>
      <textarea
        value={transcription}
        onChange={(e) => setTranscription(e.target.value)}
        placeholder={isTranscribing ? 'Transcribing...' : 'Your dictation will appear here, or type directly...'}
        className="w-full h-48 px-4 py-3 bg-gray-50 dark:bg-surface-950 border border-gray-300 dark:border-surface-800 rounded-lg text-gray-900 dark:text-gray-200 placeholder-gray-400 dark:placeholder-gray-600 resize-y focus:outline-none focus:ring-2 focus:ring-primary-500"
      />
      {transcription && (
        <p className="mt-1 text-xs text-gray-500">
          {transcription.split(/\s+/).filter(Boolean).length} words
        </p>
      )}
    </div>
  );
}
